module.exports = __webpack_public_path__ + "img/third_1.bbc837d3.png";